import { LoginError } from "@/generated/TradingGateway"
import { assertNever } from "@/utils"

/**
 * Maps the generated LoginError union to an i18n key.
 * assertNever makes this a compile error if codegen adds a variant, so a new
 * server error can never reach the UI as a raw enum name.
 */
export const loginErrorKey = (error: LoginError): string => {
  switch (error) {
    case LoginError.InvalidCredentials:
      return "login.errors.invalidCredentials"
    case LoginError.InternalError:
      return "login.errors.internalError"
    case LoginError.ServiceUnavailable:
      return "login.errors.serviceUnavailable"
    default:
      return assertNever(error)
  }
}
